/**
 * A click on a table row that opens or expands something (design-decisions.md
 * › Zeilenaktionen in Tabellen) must not fire when the person was selecting
 * text in the row — copying a booking number or an e-mail address ends with a
 * mouse-up on the row, which the browser reports as a click.
 */
export const isTextSelectionClick = (): boolean =>
    (window.getSelection?.()?.toString() ?? '') !== '';

/** Wraps a row's click handler so a text selection does not trigger it. */
export const onRowClick = (open: () => void) => (): void => {
    if (isTextSelectionClick()) return;
    open();
};
